//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Static Guids used by the Rock application */
export const DefinedValue = {
    /** Benevolence Approved */
    BenevolenceApproved: "18D3A2DA-F2BA-49AE-83EB-7E60DCD18A3B",
    /** Benevolence Denied */
    BenevolenceDenied: "3720671E-DA48-405F-A6D5-5E2D47436F9A",
    /** Benevolence Pending */
    BenevolencePending: "67B24629-62A9-436A-A98C-30A454642153",
    /** The block template for the live experience occurrences block. */
    BlockTemplateLiveExperienceOccurrences: "95837896-BB45-47FA-8517-F1C0EFE2A89C",
    /** The block template for mobile answer to prayer block. */
    BlockTemplateMobileAnswerToPrayer: "D13256E3-D9ED-45C2-8EF7-C4AABCF4B2B7",
    /** The block template for the event template on the mobile calendar item view. */
    BlockTemplateMobileCalendarEventItemOccurrenceView: "128F7350-97FD-4ECA-9C79-D02DE0C434EB",
    /** The block template for the event template on the mobile calendar event list. */
    BlockTemplateMobileCalendarEventList: "248587C7-5CE3-46B7-8728-2E03E725D0B2",
    /** The block template for the mobile communication view */
    BlockTemplateMobileCommunicationView: "0D588D84-111C-4350-98DE-460C194F5DE5",
    /** The block template for the Mobile &gt; Connection &gt; Connection Opportunity List block. */
    BlockTemplateMobileConnectionConnectionOpportunityList: "167465D9-E8D2-413C-BA99-FDA529B14E6C",
    /** The block template for the Mobile &gt; Connection &gt; Connection Request Detail block. */
    BlockTemplateMobileConnectionConnectionRequestDetail: "44538702-5157-489A-B256-217F5D1F53F4",
    /** The block template for the Mobile &gt; Connection &gt; Connection Request List block. */
    BlockTemplateMobileConnectionConnectionRequestList: "4A45926C-5571-414C-8C69-8203FDBF4AE7",
    /** The block template for the Mobile &gt; Connection &gt; Connection Type List block. */
    BlockTemplateMobileConnectionConnectionTypeList: "FECAD08A-570F-434E-BEED-412C4F2A3159",
    /** The block template for Rock.Blocks.Types.Mobile.Core.Search block. */
    BlockTemplateMobileCoreSearch: "CFEB7FA6-0F19-496B-8DCC-4D200AEEE866",
    /** The block template mobile daily challenge entry */
    BlockTemplateMobileDailyChallengeEntry: "30ECA4B6-0869-4656-A4CD-B8729CB29E76",
    /** The block template mobile event item occurrence list by audience */
    BlockTemplateMobileEventItemOccurrenceListByAudience: "26944B71-7B69-4943-8EC2-3506F728D943",
    /** The block template for the mobile group member list. */
    BlockTemplateMobileGroupMemberList: "E5618730-9E50-4BDA-9E13-D27697F83980",
    /** The block template for the mobile group member view. */
    BlockTemplateMobileGroupMemberView: "09053C7C-9374-4489-8A7B-71F02E3E7D89",
    /** The block template for the mobile group schedule preference landing page. */
    BlockTemplateMobileGroupSchedulePreferenceLandingPage: "D39CCB65-2444-48E4-9DE1-7A01AB20CB61",
    /** The block template for the mobile group schedule preference landing page. */
    BlockTemplateMobileGroupScheduleSignupLandingPage: "7F89AE4D-BD8B-49ED-B8EC-F883D43505F2",
    /** The block template for mobile group schedule toolbox block. */
    BlockTemplateMobileGroupScheduleToolbox: "7E11BEF1-F6F7-49E3-8804-90AC1CB9AD25",
    /** The block template for mobile group schedule toolbox decline modal. */
    BlockTemplateMobileGroupScheduleToolboxDeclineModal: "68ACFE34-C1D9-40C6-9AB1-9E6F4DA846EE",
    /** The block template for mobile group schedule unavailability block.  */
    BlockTemplateMobileGroupScheduleUnavailability: "48EE4803-66BE-43A0-A7CF-E2D669DB2D21",
    /** The block template for the mobile group view. */
    BlockTemplateMobileGroupView: "559346FB-C684-42CF-8F4C-CF4A1C278AD6",
    /** The block template for the mobile group finder. */
    BlockTemplateMobileGroupsGroupFinder: "1B6D540A-2E40-44F6-8AE9-2857DE913459",
    /** The block template for mobile my prayer requests. */
    BlockTemplateMobileMyPrayerRequests: "198F3006-5F0F-48AB-9EA0-2FA56F633753",
    /** The block template for the mobile notes block. */
    BlockTemplateMobileNotes: "37F44005-C4D8-4527-BA86-B6F8B72BF243",
    /** The block template for Mobile &gt; Prayer &gt; Prayer Card View block. */
    BlockTemplateMobilePrayerPrayerCardView: "DCFECA8C-CDF5-4863-851E-7EFEE6758EE9",
    /** The block template for the mobile prayer session block. */
    BlockTemplateMobilePrayerSession: "6F1F6BAB-B403-48D1-BF6A-52B16361279C",
    /** Button HTML - Approve  */
    ButtonHtmlApprove: "C88FEF94-95B9-444A-BC93-58E983F3C047",
    /** Button HTML - Cancel  */
    ButtonHtmlCancel: "5683E775-B9F3-408C-80AC-94DE0E51CF3A",
    /** Button HTML - Danger  */
    ButtonHtmlDanger: "9B329020-E074-4326-8831-9DD534F491DF",
    /** Button HTML - Default  */
    ButtonHtmlDefault: "638BEEE0-2F8F-4706-B9A4-5BAB70386697",
    /** Button HTML - Deny  */
    ButtonHtmlDeny: "D6B809A9-C1CC-4EBB-816E-33D8C1E53EA4",
    /** Button HTML - Info  */
    ButtonHtmlInfo: "3C026B37-29D4-47CB-BB6E-DA43AFE779FE",
    /** Button HTML - Primary  */
    ButtonHtmlPrimary: "FDC397CD-8B4A-436E-BEA1-BCE2E6717C03",
    /** Button HTML - Secondary  */
    ButtonHtmlSecondary: "8CF6E927-4FA5-4241-991C-391038B79631",
    /** Button HTML - Success  */
    ButtonHtmlSuccess: "53CA2CB9-8BFA-450C-A3AA-FD3F3FD3BC8A",
    /** Button HTML - Warning  */
    ButtonHtmlWarning: "F03C9591-C497-4E27-A714-6A482E745141",
    /** The campus status closed */
    CampusStatusClosed: "99D2C9CB-B6DC-49C1-B626-B76BD398B63A",
    /** The campus status open */
    CampusStatusOpen: "10696FD8-D0C7-486F-B736-5FB3F5D69F1A",
    /** The campus status pending */
    CampusStatusPending: "008209F5-144E-4282-92C3-944A4AC78700",
    /** The campus type on-line */
    CampusTypeOnline: "10101010-2DB4-4C95-B07D-C400E412289B",
    /** The campus type physical */
    CampusTypePhysical: "5A61507B-79CB-4DA2-AF43-6F82260203B3",
    /** Flot Chart Style */
    ChartStyleFlot: "B45DA8E1-B9A6-46FD-9A2B-E8440D7D6AAC",
    /** Rock Chart Style */
    ChartStyleRock: "2ABB2EA0-B551-476C-8F6B-478CD08C2227",
    /** The check in attendance type physical */
    CheckInAttendanceTypePhysical: "290CE89F-7DA0-41ED-82C1-1249A4A42BA4",
    /** The check in attendance type virtual */
    CheckInAttendanceTypeVirtual: "DF1C89D0-7D8A-48C2-B251-DFF3376C2931",
    /** Family Id Search Type. This type is for future (face recognition) support and is not currently being used. */
    CheckinSearchTypeFamilyId: "111385BB-DAEB-4CE3-A945-0B50DC15EE02",
    /** Name Search Type */
    CheckinSearchTypeName: "071D6DAA-3063-463A-B8A1-7D9A1BE1BB31",
    /** Power Search Type */
    CheckinSearchTypeNameAndPhone: "93773B0A-6E7F-1AA0-4F1D-9A4D6ACE930F",
    /** Phone number search type */
    CheckinSearchTypePhoneNumber: "F3F66040-C50F-4D13-9652-780305FFFE23",
    /** Scanned Id Search Type. This type is always supported and if a BarCode or Bio id is scanned, the attendance will be updated to reflect this type OS search was used. */
    CheckinSearchTypeScannedId: "7668CE15-E372-47EE-8FF8-6FEE09F7C858",
    /** Email communication */
    CommunicationMediumEmail: "FC51461D-0C31-4C6B-A7C8-B3E8482C1055",
    /** Conflict Profile: Avoiding  */
    ConflictProfileAvoiding: "663B0F4A-DE1F-46BE-8BDD-D7C98863DDC4",
    /** Conflict Profile: Compromising  */
    ConflictProfileCompromising: "CF78D6B1-38AA-4FF7-9A4B-E900438FA85A",
    /** Conflict Profile: Resolving  */
    ConflictProfileResolving: "DF7B1EB2-7E7E-4F91-BD26-C6DFD88E38DF",
    /** Conflict Profile: Winning  */
    ConflictProfileWinning: "56300095-86AD-43FE-98D2-50829E9223C2",
    /** Conflict Profile: Yielding  */
    ConflictProfileYeilding: "4AB06A6F-F5B1-4385-9365-199EA7969E50",
    /** The credit card type AMEX */
    CreditcardTypeAmex: "696A54E3-352C-49FB-88A1-BCDBD81AA9EC",
    /** The credit card type diners club */
    CreditcardTypeDinersClub: "1A9A4DB9-AFF3-4773-875C-C10346BD1CA7",
    /** The credit card type discover */
    CreditcardTypeDiscover: "4B746601-E9EB-4660-BA13-C0B66B24E248",
    /** The credit card type JCB */
    CreditcardTypeJcb: "4DD7F0C2-F6B7-4510-90E6-287ADC25FD05",
    /** The credit card type MasterCard */
    CreditcardTypeMastercard: "6373A4B6-4DCA-4EB6-9ADE-B30E8A7F8621",
    /** The credit card type visa */
    CreditcardTypeVisa: "FC66B5F8-634F-4800-A60D-436964D27B64",
    /** ACH */
    CurrencyTypeAch: "DABEE8FD-AEDF-43E1-8547-4C97FA14D9B6",
    /** Android Pay Currency Type */
    CurrencyTypeAndroidPay: "6151F6E0-3223-46BA-A59E-E091BE4AF75C",
    /** Apple Pay Currency Type */
    CurrencyTypeApplePay: "D42C4DF7-1AE9-4DDE-ADA2-774B866B798C",
    /** Cash */
    CurrencyTypeCash: "F3ADC889-1EE8-4EB6-B3FD-8C10F3C8AF93",
    /** Check */
    CurrencyTypeCheck: "8B086A19-405A-451F-8D44-174E92D6B402",
    /** Credit Card */
    CurrencyTypeCreditCard: "928A2E04-C77B-4282-888F-EC549CEE026A",
    /** Non-Cash */
    CurrencyTypeNoncash: "7950FF66-80EE-E8AB-4A77-4A13EDEB7513",
    /** Other Currency Type */
    CurrencyTypeOther: "0FDF0BB3-B483-4C0A-9DFF-A35ABE3B688D",
    /** Unknown Currency Type */
    CurrencyTypeUnknown: "56C9AE9C-B5EB-46D5-9650-2EF86B14F856",
    /** The default iCal description */
    DefaultIcalDescription: "DCBA4862-73E9-49B5-8AD5-08E17BE68025",
    /** Default RSS Channel Template */
    DefaultRssChannel: "D6149581-9EFC-40D8-BD38-E92C0717BEDA",
    /** Check-in Kiosk device type */
    DeviceTypeCheckinKiosk: "BC809626-1389-4543-B8BB-6FAC79C27AFD",
    /** Giving Kiosk device type */
    DeviceTypeGivingKiosk: "64A1DBE5-10AD-42F1-A9BA-646A781D4112",
    /** Printer device type */
    DeviceTypePrinter: "8284B128-E73B-4863-9FC2-43E6827B65E6",
    /** Entity Set for the purpose of doing a Person Merge request */
    EntitySetPurposePersonMergeRequest: "214EB26F-5493-4540-B2EF-F0887C8FBB9E",
    /** The financial source of bank check */
    FinancialSourceTypeBankCheck: "61E46A46-7399-4817-A6EC-3D8495E2316E",
    /** The financial source of Kiosk */
    FinancialSourceTypeKiosk: "260EEA80-821A-4F79-973F-49DF79C955F7",
    /** The financial source of Mobile Application */
    FinancialSourceTypeMobileApplication: "8ADCEC72-63FC-4F08-A4CC-72BCE470172C",
    /** The financial source of On-Site */
    FinancialSourceTypeOnsiteCollection: "BE7ECF50-52BC-4774-808D-574BA842DB98",
    /** The financial source of Text-to-Give (Give action of the SMS actions) */
    FinancialSourceTypeSmsGive: "8BA95E24-D291-499E-A535-4DCAC365689B",
    /** The financial source of Website */
    FinancialSourceTypeWebsite: "7D705CE7-7B11-4342-A58E-53617C5B4E69",
    /** Address Type - Home  */
    GroupLocationTypeHome: "8C52E53C-2A66-435A-AE6E-5EE307D9A0DC",
    /** Meeting Location Type */
    GroupLocationTypeMeetingLocation: "96D540F5-071D-4BBD-9906-28F0A64D39C4",
    /**
     * Some other type of Group Location
     * NOTE: This is not a core group location type. It'll get created if needed when importing locations from Slingshot.
     */
    GroupLocationTypeOther: "D49965C7-5254-4D2D-BC77-F390375F0C44",
    /** Address Type - Previous */
    GroupLocationTypePrevious: "853D98F1-6E08-4321-861B-520B4106CFE0",
    /** Address Type - Work */
    GroupLocationTypeWork: "E071472A-F805-4FC4-917A-D5E3C095C35C",
    /** Group RSVP Decline Reason - Childcare Not Available. */
    GroupRsvpDeclineReasonChildcare: "0E728945-3D74-4E03-9799-0CF5EE8D6B3D",
    /** Group RSVP Decline Reason - Illness. */
    GroupRsvpDeclineReasonIllness: "15B4124E-9717-4161-9974-86C4925053E3",
    /** Group RSVP Decline Reason - Other. */
    GroupRsvpDeclineReasonOther: "1634AC71-0054-4F3C-A76D-A75A48E6BA56",
    /** Group RSVP Decline Reason - Schedule Conflict. */
    GroupRsvpDeclineReasonScheduleConflict: "D5989FA4-2CE0-4427-83E4-E43F30045B43",
    /** Group RSVP Decline Reason - Vacation. */
    GroupRsvpDeclineReasonVacation: "759E0745-727B-493D-A44C-3A042A11B761",
    /** Group Type Purpose of Check-in Filter */
    GrouptypePurposeCheckinFilter: "6BCED84C-69AD-4F5A-9197-5C0F9C02DD34",
    /** Group Type Purpose of Check-in Template (Weekly Service Check-in, etc) */
    GrouptypePurposeCheckinTemplate: "4A406CB0-495B-4795-B788-52BDFDE00B01",
    /** Interaction Channel Type: Challenge Progress */
    InteractionchanneltypeChallengeProgress: "6AA529BD-9FA5-43AD-A98E-B8DF5F997146",
    /** Interaction Channel Type: Challenges */
    InteractionchanneltypeChallenges: "593607DC-4537-46E4-939F-60E0F74A1518",
    /** Interaction Channel Type: Communication */
    InteractionchanneltypeCommunication: "55004F5C-A8ED-7CB7-47EE-5988E9F8E0A8",
    /** Interaction Channel Type: Content Channel */
    InteractionchanneltypeContentchannel: "F1A19D09-E010-EEB3-465A-940A6F023CEB",
    /** Interaction Channel Type: System Events */
    InteractionchanneltypeSystemEvents: "5919214F-9C59-4913-BE4E-0DFB6A05F528",
    /** Interaction Channel Type: UrlShortener */
    InteractionchanneltypeUrlshortener: "371066D5-C5F9-4783-88C8-D9AC8DC67468",
    /** Interaction Channel Type: Website */
    InteractionchanneltypeWebsite: "E503E77D-CF35-E09F-41A2-B213184F48E8",
    /** Interaction Channel Type: Content Channel */
    InteractionchanneltypeWifiPresence: "338CB800-C556-46CD-849D-8AE58FC7CB0E",
    /** Translation Languages - English */
    LanguageEnglish: "DF0A29A7-A61E-E4A7-4F3D-58CFDD3D3871",
    /** Translation Languages - Spanish */
    LanguageSpanish: "C93CB430-8554-E599-4F49-D7F3CED2B2C7",
    /** Building Location Type */
    LocationTypeBuilding: "D9646A93-1667-4A44-82DA-12E1229B4695",
    /** Campus Location Type */
    LocationTypeCampus: "C0D7AE35-7901-4396-870E-3AAF472AAE88",
    /** Room Location Type */
    LocationTypeRoom: "107C6DA1-266D-4E1C-A443-1CD37064601D",
    /** The logging domain apple tv */
    LoggingDomainAppleTv: "41a3cbf1-769a-4d15-a13c-56d48b2009b8",
    /** The logging domain CMS */
    LoggingDomainCms: "C8A94BA4-9450-459C-B32E-E34C153AD02F",
    /** The logging domain communications */
    LoggingDomainCommunications: "8EE2657E-FF42-4E04-A5DA-15B14C8086B8",
    /** The logging domain connection */
    LoggingDomainConnection: "E5125727-8361-4BBB-A615-28B3F045BA7E",
    /** The logging domain core */
    LoggingDomainCore: "3B4F21DC-C169-453E-B119-8F33E122C84C",
    /** The logging domain CRM */
    LoggingDomainCrm: "5D737243-E7E0-4981-87A5-0787E52631C6",
    /** The logging domain event */
    LoggingDomainEvent: "EF558F8A-08DA-4001-BBAA-83390613D20E",
    /** The logging domain finance */
    LoggingDomainFinance: "24230441-AE17-4F8B-ABF7-DA32CC5F2571",
    /** The logging domain group */
    LoggingDomainGroup: "134088B7-A12A-4ED8-AA18-E059FB5D17B5",
    /** The logging domain jobs */
    LoggingDomainJobs: "2741A4A3-8E57-4B58-ABCC-56C0A31C3A25",
    /** The logging domain mobile */
    LoggingDomainMobile: "77148fef-bc4f-4b16-9d4e-e1de28149751",
    /** The logging domain other */
    LoggingDomainOther: "83CFDA4F-5867-4D4B-853F-D9B535EC5131",
    /** The logging domain prayer */
    LoggingDomainPrayer: "F460BDE7-6FFC-4979-A3AC-7BBBED05C781",
    /** The logging domain reporting */
    LoggingDomainReporting: "A2960B6B-0DF5-458B-906C-F64521CB8C83",
    /** The logging domain steps */
    LoggingDomainSteps: "0FE30F0C-E503-4DE6-A8EE-1E86B141967B",
    /** The logging domain streaks */
    LoggingDomainStreaks: "E7D3D04F-7BB8-4FE4-B2C2-924D8C0CA62B",
    /** The logging domain workflow */
    LoggingDomainWorkflow: "FF8CBA1B-5DAF-4C0E-A7DA-A0277F7AA1E5",
    /** The map marker circle */
    MapMarkerCircle: "66C27E88-6BC5-4B57-A981-0AD58481C66A",
    /** The map marker marker */
    MapMarkerMarker: "D9841DDB-BD34-45A7-97DC-141C8D6D9E84",
    /** The map marker marker with dot */
    MapMarkerMarkerWithDot: "C0FF9C66-8232-41E8-A9C0-DC9D0ECAF932",
    /** The map marker pin */
    MapMarkerPin: "52DEB4F4-7D2C-4BB0-9A70-80CCA536E3EB",
    /** Google map style */
    MapStyleGoogle: "BFC46259-FB66-4427-BF05-2B030A582BEA",
    /** The standard Rock map style */
    MapStyleRock: "FDC5D6BA-A818-4A06-96B1-9EF31B4087AC",
    /** Metric values come from a DataView */
    MetricSourceValueTypeDataview: "2EC60BCF-EF63-4CCC-A970-F152292765D0",
    /** Metric values are populated from custom Lava */
    MetricSourceValueTypeLava: "2868A3E8-4632-4966-84CD-EDB8B775D66C",
    /** Metric values are entered manually */
    MetricSourceValueTypeManual: "1D6511D6-B15D-4DED-B3C4-459CD2A7EC0E",
    /** Metric values are populated from custom SQL */
    MetricSourceValueTypeSql: "6A1E1A1B-A636-4E12-B90C-D7FD1BDAE764",
    /** Motivator: Adapting  */
    MotivatorAdapting: "BD5D99E7-E0FF-4535-8B26-BF73EF9B9F89",
    /** Motivator: Believing  */
    MotivatorBelieving: "99F598E0-E0AC-4B4B-BEAF-589D41764EE1",
    /** Motivator: Caring  */
    MotivatorCaring: "FFD7EF9C-5D68-40D2-A362-416B2D660D51",
    /** Motivator Theme: Directional  */
    MotivatorDirectionalTheme: "112A35BE-3108-48D9-B057-125A788AB531",
    /** Motivator: Empowering  */
    MotivatorEmpowering: "C171D01E-C607-488B-A550-1E341081210B",
    /** Motivator: Engaging  */
    MotivatorEngaging: "5635E95B-3A07-43B7-837A-0F131EF1DA97",
    /** Motivator: Expressing  */
    MotivatorExpressing: "FA70E27D-6642-4162-AF17-530F66B507E7",
    /** Motivator: Gathering  */
    MotivatorGathering: "73087DD2-B892-4367-894F-8922477B2F10",
    /** Motivator: Growth Propensity  */
    MotivatorGrowthPropensity: "605F3702-6AE7-4545-BEBE-23693E60031C",
    /** Motivator: Innovating  */
    MotivatorInnovating: "D84E58E4-87FC-4CEB-B83E-A2C6D186366C",
    /** Motivator Theme: Intellectual  */
    MotivatorIntellectualTheme: "58FEF15F-561D-420E-8937-6CF51D296F0E",
    /** Motivator: Leading  */
    MotivatorLeading: "6A2354C6-3FA4-4BAD-89A8-7359FEC48FE3",
    /** Motivator: Learning  */
    MotivatorLearning: "7EA44A56-58CB-4E40-9779-CC0A79772926",
    /** Motivator: Maximizing  */
    MotivatorMaximizing: "3F678404-5844-494F-BDB0-DD9FEEBC98C9",
    /** Motivator: Organizing  */
    MotivatorOrganizing: "85459C0F-65A5-48F9-86F3-40B03F9C53E9",
    /** Motivator: Pacing  */
    MotivatorPacing: "9F771853-2EBA-47A2-9AC5-26EBEA0A3B25",
    /** Motivator: Perceiving  */
    MotivatorPerceiving: "4C898A5C-B48E-4BAE-AB89-835F25A451BF",
    /** Motivator: Persevering  */
    MotivatorPersevering: "A027F6B2-56DD-4724-962D-F865606AEAB8",
    /** Motivator Theme: Positional  */
    MotivatorPositionalTheme: "84322020-4E27-44EF-88F2-EAFDB7286A01",
    /** Motivator: Relating  */
    MotivatorRelating: "D7F9BDE2-8BEB-469E-BAD9-AA4DEBD3D995",
    /** Motivator Theme: Relational */
    MotivatorRelationalTheme: "840C414E-A261-4243-8302-6117E8949FE4",
    /** Motivator: Risk-Taking  */
    MotivatorRisktaking: "4D0A1A6D-3F5A-476E-A633-04EAEF457645",
    /** Motivator: Serving  */
    MotivatorServing: "D8430EAD-7A38-4AD1-B21A-B2119EE0F1CD",
    /** Motivator: Thinking  */
    MotivatorThinking: "0D82DC77-334C-44B0-84A6-989910907DD4",
    /** Motivator: Transforming  */
    MotivatorTransforming: "2393C3CE-8E49-46FE-A75B-D5D624A37B49",
    /** Motivator: Uniting  */
    MotivatorUniting: "D7601B56-7495-4D7B-A916-8C48F78675E3",
    /** Motivator: Visioning  */
    MotivatorVisioning: "EE1603BA-41AE-4CFA-B220-065768996501",
    /** Non-Cash Asset Type: Other. */
    NoncashAssetOther: "3086AF9A-108B-47C8-B299-CECF53B9D1DF",
    /** Non-Cash Asset Type: Property. */
    NoncashAssetProperty: "FF4E8D66-CFF2-4A96-AA30-19721884C373",
    /** Non-Cash Asset Type: Stocks and Bonds. */
    NoncashAssetStocksandbonds: "B29D7D89-357F-47F9-BE7B-52AFF3892007",
    /** Non-Cash Asset Type: Vehicles. */
    NoncashAssetVehicles: "C1DCBE74-88FE-4876-8943-5783499CBBE0",
    /** The PBX CDR medium value */
    PbxCdrMediumValue: "B3904B57-62A2-57AC-43EA-94D4DEBA3D51",
    /** Person Connection Status - Attendee */
    PersonConnectionStatusAttendee: "39F491C5-D6AC-4A9B-8AC0-C431CB17D588",
    /** Person Connection Status - Member */
    PersonConnectionStatusMember: "41540783-D9EF-4C70-8F1D-C9E83D91ED5F",
    /** Person Connection Status - Participant */
    PersonConnectionStatusParticipant: "8EBC0CEB-474D-4C1B-A6BA-734C3A9AB061",
    /** Person Connection Status - Prospect */
    PersonConnectionStatusProspect: "368DD475-242C-49C4-A42C-7278BE690CC2",
    /** Person Connection Status - Visitor */
    PersonConnectionStatusVisitor: "B91BA046-BC1E-400C-B85D-638C1F4E0CE2",
    /** Person Connection Status - Web Prospect */
    PersonConnectionStatusWebProspect: "368DD475-242C-49C4-A42C-7278BE690CC2",
    /** Person Ethnicity - Hispanic or Latino */
    PersonEthnicityHispanicOrLatino: "05762BE9-32D4-4C30-9CF1-E1513C5C8360",
    /** Person Ethnicity - Not Hispanic or Latino */
    PersonEthnicityNotHispanicOrLatino: "2D1EF4CF-19E5-46BC-B4B1-591CFF57E0D8",
    /** Marital Status of Divorced */
    PersonMaritalStatusDivorced: "3B689240-24C2-434B-A7B9-A4A6CBA7928C",
    /** Marital Status of Married */
    PersonMaritalStatusMarried: "5FE5A540-7D9F-433E-B47E-4229D1472248",
    /** Marital Status of Single */
    PersonMaritalStatusSingle: "F19FC180-FE8F-4B72-A59C-8013E3B0EB0D",
    /** Person Home Phone */
    PersonPhoneTypeHome: "AA8732FB-2CEA-4C76-8D6D-6AAA2C6A4303",
    /** Person Mobile Phone */
    PersonPhoneTypeMobile: "407E7E45-7B2E-4FCD-9605-ECB1339F2453",
    /** Person Home Phone */
    PersonPhoneTypeWork: "2CC66D5A-F61C-4B74-9AF9-590A9847C13C",
    /** Person Race - American Indian or Alaska Native */
    PersonRaceAmericanIndianOrAlaskanNative: "C734961E-43A7-4FB9-999E-B60D694268B4",
    /** Person Race - Asian */
    PersonRaceAsian: "FCDC15DF-B298-4067-AE8A-431E42DA6F7E",
    /** Person Race - Black or African American */
    PersonRaceBlackOrAfricanAmerican: "3760BA55-3D68-4F55-AEEF-0AC9F39D1730",
    /** Person Race - Native Hawaiian or Pacific Islander */
    PersonRaceNativeHawaiianOrPacificIslander: "B46F3250-34A1-46E5-8171-9C8ED4FA0845",
    /** Person Race - Other */
    PersonRaceOther: "E364D2DE-81A0-4F9C-8ECF-96CC68009251",
    /** Person Race - White */
    PersonRaceWhite: "52E12EBE-1FCE-4B95-A677-AEEEDE9B1745",
    /** Record Status - Active */
    PersonRecordStatusActive: "618F906C-C33D-4FA3-8AEF-E58CB7B63F1E",
    /** Record Status - Inactive  */
    PersonRecordStatusInactive: "1DAD99D5-41A9-4865-8366-F269902B80A4",
    /** Record Status - Pending */
    PersonRecordStatusPending: "283999EC-7346-42E3-B807-BCE9B2BABB49",
    /** Record Status set to Inactive because person is Deceased  */
    PersonRecordStatusReasonDeceased: "05D35BC4-5816-4210-965F-1BF44F35A16A",
    /** Record Status set to Inactive because person moved */
    PersonRecordStatusReasonMoved: "3684CF84-F30F-4CE0-9EB9-D6AFFEA9B99B",
    /** Record Status set to Inactive because person has No Activity */
    PersonRecordStatusReasonNoActivity: "64014FE6-943D-4ACF-8014-FED9F9169AE8",
    /** Person Record Type - Business */
    PersonRecordTypeBusiness: "BF64ADD3-E70A-44CE-9C4B-E76BBED37550",
    /** Person Record Type - Nameless Person (usually due to SMS from unknown person) */
    PersonRecordTypeNameless: "721300ED-1267-4DA0-B4F2-6C6B5B17B1C5",
    /** Person Record Type - Person */
    PersonRecordTypePerson: "36CF10D6-C695-413D-8E7C-4546EFEF385E",
    /** Person Record Type - REST User */
    PersonRecordTypeRestuser: "E2261A84-831D-4234-9BE0-4D628BBE751E",
    /** Person needs review due to being Self-Inactivated */
    PersonReviewReasonSelfInactivated: "D539C356-6856-4E94-80B4-8FEA869AF38B",
    /** Person Search Type: Alternate Id */
    PersonSearchKeysAlternateId: "AD77CF28-E42B-44C2-8D5C-F6A0A6EE8022",
    /** Person Search Type: Email */
    PersonSearchKeysEmail: "D6CFD200-B33B-4D01-B49F-24325E47D8B8",
    /** Android platform */
    PersonalDevicePlatformAndroid: "63464BB8-83E2-4914-B922-5075311758F9",
    /** IOS platform */
    PersonalDevicePlatformIos: "F00515E7-4EF3-480D-A45D-372CE3D80E69",
    /** Other platform */
    PersonalDevicePlatformOther: "13091A2D-C483-46FA-B489-E5D230B353C8",
    /** Personal Device Type - Computer */
    PersonalDeviceTypeComputer: "828ADECE-EFE7-49DF-BA8C-B3F132509A95",
    /** Personal Device Type - Mobile */
    PersonalDeviceTypeMobile: "5A8F264F-3BE6-4F15-912A-3CE93A98E8F6",
    /** Personal Device Type - TV */
    PersonalDeviceTypeTv: "CA45FC83-2B1C-51AC-4B46-F3427F57116B",
    /** Project Type - In-Person */
    ProjectTypeInPerson: "FF3F0C5C-9775-4A09-9CCF-94902DB99BF6",
    /** Project Type = Project Due */
    ProjectTypeProjectDue: "C999D489-5B8F-4892-BCC3-90DFFBC524F5",
    /** Schedule Type:  Weekend Service */
    ScheduleTypeWeekendService: "033FC160-2650-4C97-8075-0C0114FA7A8D",
    /** Spiritual Gifts: Administration */
    SpiritualGiftsAdministration: "A276421D-F662-4723-99DA-6FDF3E9CFF7C",
    /** Spiritual Gifts: Apostleship */
    SpiritualGiftsApostleship: "A2C7074E-AC97-4D89-9240-47A552CDC4C0",
    /** Spiritual Gifts: Discernment */
    SpiritualGiftsDiscernment: "3EB352F3-F624-4ED6-A9EE-7951B71B1952",
    /** Spiritual Gifts: Encouragement */
    SpiritualGiftsEncouragement: "809F65A6-1759-472A-8B8B-F37009F476BF",
    /** Spiritual Gifts: Evangelism */
    SpiritualGiftsEvangelism: "0F8D41AA-7236-40BF-AA37-980BCCF4A881",
    /** Spiritual Gifts: Faith */
    SpiritualGiftsFaith: "7B30E2BA-9461-4688-9B43-D2B774E33A18",
    /** Spiritual Gifts: Giving */
    SpiritualGiftsGiving: "C4259D6E-675C-417B-9175-6D599C86A204",
    /** Spiritual Gifts: Helps */
    SpiritualGiftsHelps: "13C40209-F41D-4C1D-83D3-2EC530588245",
    /** Spiritual Gifts: Hospitality */
    SpiritualGiftsHospitality: "98D5EE08-633D-4635-80CD-169449604D18",
    /** Spiritual Gifts: Knowledge */
    SpiritualGiftsKnowledge: "462A5D10-6DEA-43D7-96EF-8F82FF1E2E14",
    /** Spiritual Gifts: Leadership */
    SpiritualGiftsLeadership: "A1CB038C-AAFC-4745-A7D2-7C8BA5028F05",
    /** Spiritual Gifts: Mercy */
    SpiritualGiftsMercy: "0894EDBA-8FC8-4433-877C-53351A06A8B7",
    /** Spiritual Gifts: Pastor-Shepherd */
    SpiritualGiftsPastorShepherd: "FC4F1B46-F0C3-45B0-9FD9-D15F4FD05A31",
    /** Spiritual Gifts: Pastor-Teacher */
    SpiritualGiftsPastorTeacher: "C7291F22-05F0-4EF9-A7C2-2CFEBFEBCB45",
    /** Spiritual Gifts: Prophecy */
    SpiritualGiftsProphecy: "4ADAEED1-D0E6-4DA4-A0BA-8E7D058075C4",
    /** Spiritual Gifts: Teaching */
    SpiritualGiftsTeaching: "E8278791-2400-4DDA-AEAA-C6F11E0AC9D0",
    /** Spiritual Gifts: Wisdom */
    SpiritualGiftsWisdom: "5F1F5A92-D981-4027-A4BC-C3642E784D0B",
    /** Default Structure Content Editor */
    StructureContentEditorDefault: "09B25845-B879-4E69-87E9-003F9380B8DD",
    /** Structure Content Editor Message Notes */
    StructureContentEditorMessageNotes: "31C63FB9-1365-4EEF-851D-8AB9A188A06C",
    /** Every two weeks */
    TransactionFrequencyBiweekly: "72990023-0D43-4554-8D32-28461CAB8920",
    /** A Frequency of First and Fifteenth */
    TransactionFrequencyFirstAndFifteenth: "C752403C-0F88-45CD-B574-069355C01D77",
    /** Monthly */
    TransactionFrequencyMonthly: "1400753C-A0F9-4A45-8A1D-81C98450BD1F",
    /** One Time */
    TransactionFrequencyOneTime: "82614683-7FB4-4F16-9087-6F85945A7B16",
    /** Monthly */
    TransactionFrequencyQuarterly: "BF08EA03-C52A-4364-B142-12EBCA7CA14A",
    /** Twice a month on the 1st and 15th */
    TransactionFrequencyTwicemonthly: "791C863D-2600-445B-98F8-3E5B66A3DEC4",
    /** Twice a year (every 6 months) */
    TransactionFrequencyTwiceyearly: "691BB8AB-5F96-4E88-847C-CB970D9E87FA",
    /** Weekly */
    TransactionFrequencyWeekly: "35711E44-131B-4534-B0B2-F0A749292362",
    /** Yearly */
    TransactionFrequencyYearly: "AC88C37A-901E-4CBB-947B-11348C208192",
    /** A Contribution Transaction */
    TransactionTypeContribution: "2D607262-52D6-4724-910D-5C6E8FB89ACC",
    /** An Event Registration Transaction */
    TransactionTypeEventRegistration: "33CB96DD-8752-4BEE-A142-88DB7DE538F0",
    /**
     * A Transaction Type of Receipt
     * NOTE: This is not a core transaction type. It'll get created if needed when importing transactions from Slingshot
     */
    TransactionTypeReceipt: "F57AAF36-F208-4A85-A078-E2B1F91798EB",
};
